import { STORE_ENTITIES } from '@app/constants'

export class Show_Loader {
  static readonly type = `[${STORE_ENTITIES.APP}] Set Loader`
  constructor() {}
}
